<template>
  <div :class="'form-group ' + classes">

    <label :for="camelCaseName">{{ name }}</label>

    <slot name="input">
      <input
        ref="input"
        :type="type"
        :id="camelCaseName"
        :name="camelCaseName"
        class="form-control"
        :required="required"
        :pattern="pattern"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
      >
    </slot>

    <small v-show="notYetValidated || valid" class="form-text text-muted">
      <slot name="note"/>
    </small>

    <div v-show="invalid" class="invalid-feedback">
      {{ feedback }}
    </div>

  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    value: { },
    classes: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    pattern: {
      type: String
    },
    validation: {
      type: Object,
      default () {
        return {}
      },
      validator (val) {
        return Object.keys(val).length === 0 ||
          ['wasValidated', 'invalid', 'feedback']
            .every(field => val.hasOwnProperty(field))
      }
    }
  },
  computed: {
    camelCaseName () {
      const upperCase = (word) => (word[0].toUpperCase() + word.slice(1))
      const words = this.name.split(' ')
      return words[0].toLowerCase() + words.slice(1).map(upperCase)
    },
    notYetValidated () {
      return !this.validation.wasValidated
    },
    feedback () {
      return this.validation.feedback
    },
    invalid () {
      const _invalid = this.validation.invalid

      // Most instances of this component use the default #input slot, which makes
      // this.$refs.input avaiable. The 'description' field of the table (built with Quill)
      // is the only instance that uses a custom #input slot, which makes inputElt
      // undefined in that case. All of this is to say that custom validation
      // messages will work for all instances so far besides the description instance (4/8/19)
      const inputElt = this.$refs.input
      if (inputElt && typeof inputElt.setCustomValidity === 'function') {
        inputElt.setCustomValidity(_invalid ? this.feedback : '')
      }

      return _invalid
    },
    valid () {
      return !this.invalid
    }
  }
}
</script>
